/**
 * Provider gating for the Data Collection AI surfaces (Generate Data with AI
 * and the Dataset Retrieval Agent). Both features generate free text, so
 * classification-only decision-model providers (TypeSafe AI's Jev — see
 * ``NATIVE_CLASS_PROBS_PROVIDERS``) can never serve them, regardless of the
 * task type.
 */

import { NATIVE_CLASS_PROBS_PROVIDERS } from '@/shared/domain/taskTypes';

/**
 * Analyze the commercial-model catalog for the text-generation AI surfaces.
 *
 * While the catalog is still loading both flags are ``false`` so the warning
 * never flashes on first paint (same convention as the other Data Collection
 * AI surfaces).
 *
 * @param {Object} availableProviders - ``GET /available-models`` map from
 *   ``useCommercialModels`` (keyed by provider name).
 * @param {boolean} isLoading - Catalog fetch still in flight.
 * @returns {{ hasNoProviders: boolean, typeSafeOnly: boolean }}
 *   ``hasNoProviders``: catalog loaded with no configured provider at all.
 *   ``typeSafeOnly``: providers are configured, but every one of them is a
 *   classification-only decision model (TypeSafe AI) — the feature must be
 *   gated with the TypeSafe-specific warning.
 */
export function analyzeProviderGate(availableProviders, isLoading) {
    if (isLoading) {
        return { hasNoProviders: false, typeSafeOnly: false };
    }
    const providers = Object.keys(availableProviders || {});
    if (providers.length === 0) {
        return { hasNoProviders: true, typeSafeOnly: false };
    }
    return {
        hasNoProviders: false,
        typeSafeOnly: providers.every((provider) =>
            NATIVE_CLASS_PROBS_PROVIDERS.includes(provider)
        ),
    };
}
